import React from 'react';
import { connect } from 'react-redux';
import styles from './PriceInformation.less';
import PriceInformationDetails from './PriceInformationDetails';
import {
  getAddressTitleAndSubtitle,
  getLatestQuarterPriceInformationData,
} from '../../selectors/selectors';

const PriceInformation = ({ addressTitle, quarterPriceInformation }) => (
  <div className={`margin-top-l ${styles.priceInformation}`}>
    <div className="margin-bottom-m">
      <h2 className={styles.title}>Informationen zu den Immobilienpreisen in {addressTitle}</h2>
    </div>
    <PriceInformationDetails addressTitle={addressTitle} priceInformation={quarterPriceInformation} />
  </div>
);

const mapStateToProps = (state) => ({
  addressTitle: getAddressTitleAndSubtitle(state).title,
  quarterPriceInformation: getLatestQuarterPriceInformationData(state),
});

export default connect(mapStateToProps)(PriceInformation);
